// import { useTranslation, Trans } from 'react-i18next';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import Api from '../../../services/api.service';

import Loading from '../../../components/Loading/loading';
import LogoLong from '../../../components/Logos/logo-long';
import FirstStepAcceptQuotation from './first-step';
// import SecondStepAcceptQuotation from './second-step';
import ThirdStepAcceptQuotation from './third-step';
import RefusedStepAcceptQuotation from './refused-step';
import ValidatedStepAcceptQuotation from './validated-step';
import Helper from '../../../services/helper.service';
import ModifiedStepAcceptQuotation from './modified-step';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import ErrorStepQuotation from './error-step';
import PaidStepAcceptQuotation from './paid-step';
import * as _ from 'lodash';
import DepositPaidStepQuotation from './deposit-paid-step';
import I18nComponentChooseLanguage from '../../../components/Widgets/i18n-choose-language';

export default function QuotationGroupPage() {
    const { id } = useParams();
    const { t, i18n } = useTranslation();

    const [loading, setLoading] = useState(true);
    const [group, setGroup] = useState(null);          // the group object
    const [quotes, setQuotes] = useState([]);

    const [step, setStep] = useState("step1");

    useEffect(() => {
        (async () => {
            try {
                const { data: res } = await Api.getQuotationGroup(id);

                if (res.status) {
                    const group = res.data;
                    setGroup(group);

                    let loaded = [];
                    const qEntries = group.quotationIds || [];
                    const areObjects = qEntries.length && typeof qEntries[0] === 'object';

                    if (areObjects) {
                        loaded = qEntries;

                    } else if (qEntries.length) {
                        const { data } = await Api.getQuotationsByIds(qEntries);
                        if (!data?.status) throw new Error(data?.error || 'Unable to load quotations');
                        loaded = data.data || [];
                    }

                    setQuotes(loaded);

                    const firstLang = _.get(loaded, '[0].mainInfos.language');
                    if (firstLang) i18n.changeLanguage(firstLang);

                    setStep(Helper.getStepQuotationGroup(group.status));
                } else {
                    setStep("error")
                    console.log("error");
                }

                setLoading(false);

            } catch (e) {
                setStep('error');

            } finally {
                setLoading(false);
            }
        })();
    }, [id, i18n]);

    const handleReturnedData = (data) => {
        setStep(data);
    };

    return (
        <div className='bg-backgroundColor min-h-screen'>
            <Helmet>
                <title>{t('pageQuotation.page')}</title>
            </Helmet>

            <header className="flex justify-center pt-8">
                <LogoLong width={250} height={64} />
                <div className='absolute top-[15px] right-[15px]'>
                    <I18nComponentChooseLanguage />
                </div>
            </header>

            <div className='m-auto max-w-5xl pt-14'>
                {loading ? (
                    <Loading />
                ) : (
                    <>
                        {step === "error" && (
                            <ErrorStepQuotation />
                        )}

                        {step === "step1" && (
                            <FirstStepAcceptQuotation group={group} quotations={quotes} returnedData={handleReturnedData} />
                        )}

                        {/* {step === "step2" && (
                            <SecondStepAcceptQuotation group={group} quotations={quotes} returnedData={handleReturnedData} />
                        )} */}

                        {step === "step3" && (
                            <ThirdStepAcceptQuotation group={group} quotations={quotes} returnedData={handleReturnedData} />
                        )}

                        {step === "stepDepositPaid" && (
                            <DepositPaidStepQuotation group={group} quotations={quotes} returnedData={handleReturnedData} />
                        )}

                        {step === "refused" && (
                            <RefusedStepAcceptQuotation group={group} quotations={quotes} returnedData={handleReturnedData} />
                        )}

                        {step === "modified" && (
                            <ModifiedStepAcceptQuotation />
                        )}

                        {step === "validated" && (
                            <ValidatedStepAcceptQuotation />
                        )}

                        {step === "paid" && (
                            <PaidStepAcceptQuotation quotation={quotes[0]} />
                        )}
                    </>
                )}
            </div>
        </div>
    );
}